import Vue from 'vue';
import SkyReveal from './sky-reveal';

// Main component
Vue.component('sky-reveal', SkyReveal);

export default SkyReveal;



// WEBPACK FOOTER //
// ./scripts/sky-reveal/index.js